<template>
    <div>
        <!-- filter -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Amount more than (in pennies)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input class="input oc-input"
                               type="text"
                               v-model="minAmount">
                    </p>
                </div>
                <div class="field">
                    <div class="control">
                        <label class="checkbox">
                            <input type="checkbox" v-model="filterDepositWithdraw">
                            Filter Deposit/Withdrawal
                        </label>
                    </div>
                </div>
                <div class="field">
                    <p class="control">
                        <a class="button is-info"
                           @click="loadTransactions()">
                            Search
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <!-- list -->
        <table class="table is-fullwidth is-size-7 is-hoverable">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Num</th>
                    <th v-if="showUser">Player</th>
                    <th>Source</th>
                    <th>Date</th>
                    <th>Real</th>
                    <th>Bonus</th>
                    <th>Res. real.</th>
                    <th>Res. bonus.</th>
                    <th>Sum</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="transaction in transactions"
                    :key="transaction.id">
                    <td>{{transaction.id}}</td>
                    <td>{{transaction.number}}</td>
                    <td v-if="showUser">
                        <router-link :to="{ name: 'player', params: { playerId: transaction.userId } }">{{transaction.username}}</router-link>
                    </td>
                    <td>
                        {{transaction.source}}
                        <template v-if="transaction.source == 'MerchantService'">
                            - {{transaction.type}}
                        </template>
                        <template v-if="transaction.games && transaction.games.length">
                            <span class="has-text-grey"
                                  v-for="game in transaction.games">{{game.gameId}}</span>
                        </template>
                        <span v-if="transaction.pinInfo"
                              class="has-text-grey">
                            pin <span class="has-text-danger has-text-weight-semibold">{{transaction.pinInfo.pin}}</span>
                        </span>
                    </td>
                    <td>
                        {{transaction.date | datetime}}
                    </td>
                    <td :class="{'has-text-danger':transaction.type == 'Withdraw', 'has-text-success':transaction.type == 'Deposit'}">
                        {{transaction.type == 'Deposit' ? '+' : (transaction.type == 'Withdraw' ? '-' : '')}}
                        {{transaction.amount | currency(transaction.currency)}}
                    </td>
                    <td :class="{'has-text-danger':transaction.type == 'Withdraw', 'has-text-success':transaction.type == 'Deposit'}">
                        {{transaction.type == 'Deposit' ? '+' : (transaction.type == 'Withdraw' ? '-' : '')}}
                        {{transaction.bonus | currency(transaction.currency)}}
                    </td>
                    <td class="has-text-weight-semibold">
                        {{transaction.balanceAfter | currency(transaction.currency)}}
                    </td>
                    <td class="has-text-weight-semibold">
                        {{transaction.bonusAfter | currency(transaction.currency)}}
                    </td>
                    <td>
                        {{transaction.balanceAfter + transaction.bonusAfter | currency(transaction.currency)}}
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination @change="loadTransactions();"
                    ref="pagination"
                    :page-size="100" />

        <!-- total -->
        <div class="box" style="margin: 2rem 0 2rem 0;">
            <div class="field">
                <p class="control">
                    <a class="button is-success"
                        @click="calculateTotal()"
                        :disabled="calculatingTotal">
                        <template v-if="calculatingTotal">{{calculatingTotalProgress}}%</template>
                        <template v-else>Calculate total</template>
                    </a>
                </p>
            </div>

            <template v-if="total && !calculatingTotal">
                <template v-for="currencyData in total.currencyData">
                    <h5>{{currencyData.currency}}</h5>
                    <table v-for="methodData in currencyData.methodData" class="table is-hoverable is-size-7 is-bordered">
                        <template v-if="methodData.method == 'game'">
                            <tr>
                                <th colspan="6" class="has-text-centered">{{methodData.method}}</th>
                            </tr>
                            <tr>
                                <td>real bet</td>
                                <td>real win</td>
                                <td>bonus bet</td>
                                <td>bonus win</td>
                                <td>total bet</td>
                                <td>total win</td>
                            </tr>
                            <tr>
                                <td>{{methodData.realOut | currency(currencyData.currency)}}</td>
                                <td>{{methodData.realIn | currency(currencyData.currency)}}</td>
                                <td>{{methodData.bonusOut | currency(currencyData.currency)}}</td>
                                <td>{{methodData.bonusIn | currency(currencyData.currency)}}</td>
                                <td>{{methodData.realOut + methodData.bonusOut | currency(currencyData.currency)}}</td>
                                <td>{{methodData.realIn + methodData.bonusIn | currency(currencyData.currency)}}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <th colspan="6" class="has-text-centered">{{methodData.method}}</th>
                            </tr>
                            <tr>
                                <td>real deposit</td>
                                <td>real withdrawal</td>
                                <td>bonus deposit</td>
                                <td>bonus withdrawal</td>
                                <td>total deposit</td>
                                <td>total withdrawal</td>
                            </tr>
                            <tr>
                                <td>{{methodData.realIn | currency(currencyData.currency)}}</td>
                                <td>{{methodData.realOut | currency(currencyData.currency)}}</td>
                                <td>{{methodData.bonusIn | currency(currencyData.currency)}}</td>
                                <td>{{methodData.bonusOut | currency(currencyData.currency)}}</td>
                                <td>{{methodData.realIn + methodData.bonusIn | currency(currencyData.currency)}}</td>
                                <td>{{methodData.realOut + methodData.bonusOut | currency(currencyData.currency)}}</td>
                            </tr>
                        </template>
                    </table>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import pagination from "./pagination.vue";

export default {
    name: "transactions-list",
    components: { pagination },
    props: {
        dataFunc: {
            type: Function,
            required: true
        },
        showUser: {
            type: Boolean,
            default: false
        },
        minAmountFilter: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            transactions: [],
            minAmount: 0,
            filterDepositWithdraw: false,
            total: null,
            calculatingTotal: false,
            calculatingTotalProgress: 0
        };
    },
    async mounted() {
        this.minAmount = this.minAmountFilter;
        await this.loadTransactions();
    },
    methods: {
        async reset() {
            await this.loadTransactions(0);
        },
        async loadTransactions(page) {
            let filter = {
                pageNumber: page || this.$refs.pagination.pageNumber,
                pageSize: this.$refs.pagination.pageSize,
                minAmount: this.minAmount,
                filterDepositWithdraw: this.filterDepositWithdraw
            };
            const data = await this.dataFunc(filter);
            this.transactions = data.items;
            this.$refs.pagination.set(data.pageNumber, data.totalPages);
        },
        async calculateTotal() {
            this.calculatingTotal = true;
            this.calculatingTotalProgress = 0;
            this.total = null;
            let totalPages = 1;
            let total = {
                currencyData: []
            };
            for (let page = 1; page <= totalPages; page++) {
                let filter = {
                    pageNumber: page,
                    pageSize: this.$refs.pagination.pageSize,
                    minAmount: this.minAmountVal,
                    filterDepositWithdraw: this.filterDepositWithdraw
                };
                const data = await this.dataFunc(filter);
                totalPages = data.totalPages;
                data.items.forEach(t => {
                    // currency
                    let currency = t.currency;
                    let currencyStats = total.currencyData.find(c => c.currency == currency);
                    if (!currencyStats) {
                        currencyStats = {
                            currency: currency,
                            methodData: []
                        }
                        total.currencyData.push(currencyStats);
                    }

                    // method
                    let method = t.method.toLowerCase();
                    let methodStats = currencyStats.methodData.find(m => m.method == method);
                    if (!methodStats) {
                        methodStats = {
                            method: method,
                            realIn: 0,
                            realOut: 0,
                            bonusIn: 0,
                            bonusOut: 0
                        }
                        currencyStats.methodData.push(methodStats);
                    }

                    let type = t.type.toLowerCase();
                    if (type == 'deposit') {
                        methodStats.realIn += t.amount || 0;
                        methodStats.bonusIn += t.bonus || 0;
                    }
                    if (type == 'withdraw') {
                        methodStats.realOut += t.amount || 0;
                        methodStats.bonusOut += t.bonus || 0;
                    }
                });
                this.calculatingTotalProgress = parseInt((page / totalPages) * 100);
            }
            this.total = total;
            this.calculatingTotal = false;
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/common/transactions-list.vue